import { useOpenClientDownload } from '@/shared/hooks/useClientDownload';

/** Faixa "Sua lenda comeca aqui" no fim do resumo — os dois botoes levam ao client. */
export function DashboardCta() {
  const openDownload = useOpenClientDownload();
  return (
    <section className="dashboard-cta panel-surface">
      <div className="dashboard-cta-shade"></div>
      <div className="dashboard-cta-copy">
        <h2>Sua lenda<br /><span>começa aqui</span></h2>
        <p>Junte-se a milhares de jogadores em uma nova jornada por Nevareth.<br />Liberdade, desafio e um mundo inteiro para explorar.</p>
      </div>
      <div className="dashboard-cta-actions">
        <button className="btn btn-gold" onClick={openDownload}>♙ Jogar agora</button>
        <button className="btn btn-dark" onClick={openDownload}>⇩ Baixar cliente</button>
      </div>
    </section>
  );
}
